const ResponseTypes = {
    BLOB: 'blob'
};

export default ResponseTypes;